import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import httphelper from './assets/unit/HttpHelper';
import Ellipsis from './assets/unit/ellipsis';
import VueCookies from 'vue-cookies';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.config.productionTip = false;

Vue.use(ElementUI);
Vue.use(VueCookies);
Vue.prototype.httphelper = httphelper;
Vue.prototype.ellipsis = Ellipsis;

router.beforeEach((_to, from, next) => {
  let flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  // console.log(navigator.userAgent, flag);
  if (flag) {
    window.location.href = 'https://hcph5.gp519.com/';
  } else {
    next();
  }
});

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');
